import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

export const sadashboardGuard = (): boolean => {
  const router = inject(Router);
  const storage = inject(StorageService);

  const token = storage.get('access_token');
  const userStr = storage.get('user');

  if (!token || !userStr) {
    router.navigate(['/'], { replaceUrl: true });
    return false;
  }

  try {
    const user = JSON.parse(userStr);
    if (user.user_type === 'admin' || user.user_type === 'superadmin') return true;
    if (user.user_type === 'provider') return true;
    router.navigate(['/profile'], { replaceUrl: true });
    return false;
  } catch {
    router.navigate(['/'], { replaceUrl: true });
    return false;
  }
};
